import { Component, Vue } from 'vue-facing-decorator';;
import { ElMessage, ElMessageBox } from 'element-plus';
import { Check, CircleClose, Search, Close, WarningFilled, Stamp, Refresh  } from '@element-plus/icons-vue';
import Status from "@/models/EnumStatus";
import Header from '@/components/Header/Header.vue';
import Navigation from '@/components/Navigation/Navigation.vue';
import NavigationIndex from "@/models/EnumNavigationIndex";
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue';
import AuthService from '@/services/AuthService';
import ApiService from '@/services/ApiService';
import WebSocketService from '@/services/WebSocketService';

@Component(
{
    components:
    {
        Header,
        Breadcrumbs,
        Navigation,
        Check,
        CircleClose,
        Search,
        Close,
        WarningFilled,
        Stamp,
        Refresh
    },
    enums:
    {
        Status,
        NavigationIndex
    }
})

export default class QuestionnaireAppeal extends Vue 
{
    private loading : boolean = true;
    private loadingQuestions : boolean = true;
    private loadingOptions : boolean = true;
    private hasPermission: boolean[] = [] as boolean[];
    private testId : number = 0;
    private testName : string = '';
    private testDate : Date = new Date();
    private questionId : string = "";
    private questionName : string = "";
    private showQuestionPreview : boolean = false;
    private currentOption : OptionModel | undefined;
    private questionnaireModelList : QuestionnaireView[] | undefined;
    private optionModelList : OptionsForQuestionModel[] | undefined;
    private testModel : TestModel | undefined = {} as TestModel;
    private windowWidth : number = window.innerWidth;
    private windowHeight : number = window.innerHeight;
    
    public async mounted()
    {
        // get permissions
        await AuthService.getPermissions();
        this.hasPermission['TEST_SELECT'] = AuthService.hasPermission('TEST_SELECT');
        this.hasPermission['TEST_INSERT'] = AuthService.hasPermission('TEST_INSERT');
        this.hasPermission['TEST_UPDATE'] = AuthService.hasPermission('TEST_UPDATE');
        this.hasPermission['TEST_DELETE'] = AuthService.hasPermission('TEST_DELETE');
        this.hasPermission['TEST_QUESTION'] = AuthService.hasPermission('TEST_QUESTION');
        
        if (this.hasPermission['TEST_UPDATE'] || this.hasPermission['TEST_QUESTION'])
        {
            // get test id from get request
            this.testId = this.$route.params.testid as string;

            // load test from db
            this.testModel = await ApiService.getTest(this.testId);
            
            if (!this.testModel) 
            {
                this.$router.push('/test');
                return;
            }
            else
            {
                this.testName = this.testModel.name;
                this.testDate = this.testModel.testdate;

                await this.loadQuestionnaire();
            }
        }

        window.addEventListener('resize', this.onWindowResize);

        this.loading = false;
    }

    private beforeUnmount()
    {
        window.removeEventListener('resize', this.onWindowResize);
    }

	private onWindowResize(e : any)
    {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
    }

    private async loadQuestionnaire()
    {
        this.loadingQuestions = true;
        this.questionnaireModelList = await ApiService.getQuestionnaireForTest(this.testModel.testid.toString());
        this.loadingQuestions = false;
    }

    private async loadQuestionOptions(questionid : string)
    {
        this.loadingOptions = true;
        this.optionModelList = await ApiService.getOptionsForQuestion(this.testModel.testid.toString(), questionid);
        this.loadingOptions = false;
    }

    private async lockOption()
    {
        if (!this.currentOption) return;

        await ApiService.lockOption(this.currentOption);
    }
    
    private onLockConfirm(action : string)
    {
        if (!this.currentOption) return;

        if (action == 'confirm')
        {
            this.lockOption();
        }
    }

    private onReplaceConfirm(action : string)
    {
        if (action == 'confirm' && this.questionnaireIdToReplace > 0)
        {
            this.replaceQuestion(this.questionnaireIdToReplace);
        }
    }
    
    private async replaceQuestion(questionnaireid : number)
    {
        let ok : boolean = await ApiService.replaceQuestion(questionnaireid.toString());

        if (ok)
        {
            await this.loadQuestionnaire();
        }
        else
        {
		    ElMessage({message: "Es ist keine alternative Frage verfügbar.", type: 'error'});
        }
    }

    public onQuestionReplaceClick(questionnaireid : number)
    {
        this.questionnaireIdToReplace = questionnaireid;

        ElMessageBox.confirm('Soll diese Frage durch eine andere aus der gleichen Kategorie ersetzt werden?', 'Warning', 
        {
            type: 'warning',
            title: '',
            callback: this.onReplaceConfirm,
            confirmButtonText: 'Ersetzen',
            cancelButtonText: 'Abbrechen'
        });
    }

    public async onQuestionPreviewClick(questionid : number, question : string)
    {
        this.questionId = questionid.toString();
        this.questionName = question;
        this.showQuestionPreview = true;

        await this.loadQuestionOptions(questionid.toString());
    }
    
    public async onQuestionApproveClick(item : QuestionnaireModel)
    {
        item.isapproved = !item.isapproved;

        if (item.isapproved)
        {
            await ApiService.approveQuestion(item.questionnaireid.toString());
        }
        else
        {
            await ApiService.rejectQuestion(item.questionnaireid.toString());
        }
    }

    private onLockOptionClick(option : OptionModel)
    {
        this.currentOption = option;

        ElMessageBox.confirm('Soll diese Antwortmöglichkeit wirklich gesperrt und nicht mehr verwendet werden?', 'Warning', 
        {
            type: 'warning',
            title: '',
            callback: this.onLockConfirm,
            confirmButtonText: 'Sperren',
            cancelButtonText: 'Abbrechen'
        });
    }
    
    private onBackClick()
    {
        if (this.testModel)
        {
            this.$router.push(`/test/${this.testModel.testid.toString()}`);
        }
    }
}
